module.exports = __webpack_public_path__ + "svg/puzzle.svg?d2aab431b1521401bc73258b33eea622";